import { Component, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { DateAdapter } from "@angular/material/core";
import moment from 'moment';
import { NuevoCentroContratistaComponent } from 'src/app/components/portal-contratista/centro/formularios/nuevo-centro-contratista/nuevo-centro-contratista.component';
import { MatDialog } from "@angular/material/dialog";

//SERVICIOS
import { CentroService } from 'src/app/services/centro.service';
import { GestorService } from 'src/app/services/gestor.service';
import { ContratistaService } from 'src/app/services/contratista.service';
import { ConfirmacionService } from 'src/app/services/confirmacion.service';
import { DetalleService } from 'src/app/services/detalle.service'
import { DetalleCentroComponent } from 'src/app/components/portal-inproeco/centro/tabla-centros/detalle-centro/detalle-centro.component';
import { InstalacionService } from 'src/app/services/instalacion.service';
import { TransportistaService } from 'src/app/services/transportista.service';
import { Workbook } from 'exceljs';

import * as fs from 'file-saver';
import { LoginService } from 'src/app/services/login.service';
import { DocumentoService } from 'src/app/services/documento.service';
import Chart from 'chart.js';
import { ClienteService } from 'src/app/services/cliente.service';
import { element } from 'protractor';
import { AddClienteComponent } from '../formularios/add-cliente/add-cliente.component';
import { DocAdicionalService } from 'src/app/services/doc-adicional.service';

@Component({
  selector: 'app-tabla-centros-contratista',
  templateUrl: './tabla-centros-contratista.component.html',
  styleUrls: ['./tabla-centros-contratista.component.scss']
})
export class TablaCentrosContratistaComponent implements OnInit {

  public centros: any
  public loading: Boolean
  public tableColumns: String[]
  public title: String
  public dataSource?: any
  public filterValue?: string
  userLog: any
  role: any

  idGestor: any
  gestorCentros: any[] = []
  arrayGestorCentros: any[] = []
  idInstalacion: any
  arrayCentros: any[] = []
  idTransportista: any
  transportistaCentros: any[] = []
  arrayTransportistaCentros: any[] = []
  centroSeleccionado: any = []
  centrosFilter: any
  selectedValue:any

  stackedBarChartCentro: any;
  stackedBarChartAdicCentro: any;
  stackedHorizontalBarOptions: any;
  allIdCentros: any[] = []

  stackedBarChartTitleCentro: any;
  licenciasPagadas:any
  idCliente:any
  centrosCliente:any
  gestoresCliente:any
  transportistaCliente:any
  centrosColor:any =[]


  @ViewChild('stackedCanvasTitleCentro') stackedCanvasTitleCentro: any;
  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;
  @ViewChildren('stackedCanvasCentro') stackedCanvasCentro: any;
  @ViewChildren('canvasAdicCentro') canvasAdicCentro: any;

  constructor(private apollo: Apollo, private centroService: CentroService,
   private detalleService: DetalleService, private gestorService: GestorService, private transportistaService: TransportistaService,
   private confirmacionService: ConfirmacionService, private instalacionService: InstalacionService, 
   private contratistaService: ContratistaService, date: DateAdapter<Date>, 
   public dialog: MatDialog, private loginService: LoginService, 
   private documentoService: DocumentoService, private clienteService: ClienteService, private docAdicService: DocAdicionalService) {
    this.loading = false;
    this.title = "Centros"
    date.getFirstDayOfWeek = () => 1
    this.userLog = this.loginService.getUserData()
    this.centrosColor = this.centroService.getCentros()
    this.role = this.userLog.rol

    this.role == 'user' ?
      this.tableColumns = ['cliente.nombreComercial','id', 'nombre', 'contactoResponsable.nombre', 'direccion.nombre', 'indicadores']
      : this.tableColumns = ['cliente.nombreComercial','id', 'nombre', 'contactoResponsable.nombre', 'direccion.nombre', 'indicadores', 'acciones']
    this.stackedHorizontalBarOptions = {
      hover: {
        animationDuration:0
      },
      layout: {
        padding: 0
      },
      legend: {
        display: false
      },
      maintainAspectRatio: true,
      responsive: false,
      scales: {
        xAxes: [
          {
            gridLines: {
              display: false,
              drawBorder: false
            },
            scaleLabel: {
              display: false
            },
            stacked: true,
            ticks: {
              display: false,
              beginAtZero: false,
              fontFamily: "Helvetica, sans-serif",
              fontSize: 14
            }
          }
        ],
        yAxes: [
          {
            gridLines: {
              display: false,
              drawBorder: false
            },
            scaleLabel: {
              display: false
            },
            stacked: true,
            ticks: {
              display: false,
              fontFamily: "Helvetica, sans-serif",
              fontSize: 14
            }
          }
        ]
      },
      tooltips: {
        enabled: false
      }
    };
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    
    this.idGestor= this.gestorService.getIdGestor()
    this.idTransportista = this.transportistaService.getIdTransportista()
    this.idInstalacion= this.instalacionService.getIdInstalacion()

    if (this.idGestor) {
      this.getCentrosByGestor() 
      return
    } else if (this.idTransportista) {
      this.getCentrosByTransportista() 
      return
    } else if (this.idInstalacion){
        this.getCentrosByInstalacion()
        return
    } else {
      setTimeout(() => {
      this.getCentrosByContratista()
    }, 300);
    }
    /* this.getCentrosByContratistaFilter() */
  
   
    /* this.getClienteById() */
  }
  /* getCentrosByContratistaFilter() {
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getCentrosByContratistaTablas(),
      variables: {
        "id": this.userLog.contratista.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {

        this.centrosFilter = data.contratista.centros
       console.log(data)
       this.licenciasPagadas = data.contratista.licenciasPagadas
       console.log(this.licenciasPagadas)
       console.log(this.centrosFilter)
        this.centrosFilter.forEach((centro:any) => {
          this.getDocumentosByCentro(centro.id)
      
        });

      })
      
  } */

  setIdCliente(id:any){
    this.clienteService.setIdCliente(id)
  }

  getClienteById(id:any){
    this.apollo.watchQuery<any>({
      query: this.clienteService.getClienteById(),
   
      variables: {
        "id": id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
  
        this.centrosCliente =  data.cliente.centros
        this.gestoresCliente = data.cliente.gestores
        this.transportistaCliente = data.cliente.transportistas

      })
  }

  popupComprarLicencia(){
    this.confirmacionService.openPopUp('Sin Licencias', 'No puede añadir mas centros porque se ha quedado sin licencias, si lo desea puede añadir más licencias pagando en la pestaña "LICENCIAS"')
  }
  
  /* selectCentro(e:any){

    const centro= e.value;
    console.log(centro)
    if (e.selected) {
      this.centroSeleccionado.push(centro)
      this.dataSource = new MatTableDataSource(this.centroSeleccionado)
      this.getDocumentosByCentro(centro.id)
    }else{
      this.centroSeleccionado = this.centroSeleccionado.filter((i:any)=> i !== centro )
      this.dataSource = new MatTableDataSource(this.centroSeleccionado)
     
 
      if (this.centroSeleccionado.length == 0) {
        this.dataSource = new MatTableDataSource(this.centros)
        location.reload()
      }
    }
  }

  unselect(): void {
    
    this.selectedValue = undefined;
    this.centroSeleccionado = []
    this.dataSource = new MatTableDataSource(this.centrosFilter)
    this.getCentrosByContratistaFilter()
 }

 */

  exportAsExcel() {

    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet("Datos de Centros");
    let header = [/* "Id", */ "Nombre", "Cliente", "Nombre Contacto", "Email Contacto", "Dirección", "NIMA", "Productor de RP", "Gran Productor de RP", "Gestores", "Transportistas"]
    let headerRow = worksheet.addRow(header);

    for (let centro of this.centros) {
      // let keys = Object.keys(centro);
      let temp = []
      let gestores: any =[]
      let gestoresExcel : String
      let transportistas: any =[]
      let transportistasExcel: String
      // for (let key of keys) {
      //   temp.push(centro[key])
      // }

      // MAPEADO //
      /* temp.push(centro["IdCentro"]) */
      temp.push(centro["nombre"])
      temp.push(centro["clientes"][0] ? centro["clientes"][0]["nombreComercial"] : '')
      temp.push(centro["contactoResponsable"] ? centro["contactoResponsable"]["nombre"] : '')
      temp.push(centro["contactoResponsable"] ? centro["contactoResponsable"]["mail"] : '')
      temp.push(centro["direccion"] ? centro["direccion"]["tipoVia"] + ' ' + centro["direccion"]["nombre"] + ', ' + centro["direccion"]["numero"]  + ', ' + centro["direccion"]["pta"] + ', ' + centro["direccion"]["letra"] + ', ' + centro["direccion"]["provincia"] + ', ' + centro["direccion"]["ccaa"] + '- ' + centro["direccion"]["codigoPostal"]: '')
      temp.push(centro["nima"])

      if (centro.resPeligrosos == true) {
        temp.push("Si")
      } else {
        temp.push("No")
      }

      if (centro.GPResPeligrosos == true) {
        temp.push("Si")
      } else {
        temp.push("No")
      }
      
      centro?.gestors.forEach((element: any) => {
        gestores.push(" " + element?.nombre)
      });
      gestoresExcel = gestores.toString().replace("[", " ").replace("]", " ")
      temp.push(gestoresExcel)
      
      centro?.transportistas.forEach((element: any) => {
        transportistas.push(" " + element?.nombre)
      });
      transportistasExcel = transportistas.toString().replace("[", " ").replace("]", " ")
      temp.push(transportistasExcel)

      worksheet.addRow(temp)

    }

    let fname = "Tabla Centros"

    workbook.xlsx.writeBuffer().then((data) => {

      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, fname + '-' + new Date().valueOf() + '.xlsx');
    });
  }


  

  getCentrosByContratista() {
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getCentrosByContratistaTablas(),
      variables: {
        "id": this.userLog.contratista.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
     
        this.centros = data.contratista.centros;
        /* console.log(this.centros); */
        
       
        if (this.centrosColor?.length > 0) {
       
          this.setDataTableOptions(this.centrosColor)
        }else{
          this.setDataTableOptions(this.centros)
        }
        
        this.centros.forEach((centro:any) => {
          this.getDocumentosByCentro(centro.id)
          this.getDocumentosAdicByCentro(centro.id)
        });
       /*  this.getDocumentosAllCentros() */
        this.licenciasPagadas = data.contratista.licenciasPagadas
      })
  }

  getCentrosByGestor() {
    this.apollo.watchQuery<any>({
      query: this.centroService.getCentrosByGestor(),
      fetchPolicy: "no-cache",
      variables: {
       "id": this.idGestor
      },
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        
        this.loading = loading;
  
        this.gestorCentros = data.gestor.centros
   
       this.gestorCentros.forEach((gestor:any) => {
            if(gestor.contratista?.id === this.userLog.contratista.id) {
                  this.arrayGestorCentros.push(gestor)
                }
            
        });
        this.setDataTableOptions(this.arrayGestorCentros) 
        this.arrayGestorCentros.forEach((centro:any) => {
     /*      this.getDocumentosByCentro(centro.id) */
        });
        
      })
  }

  getCentrosByTransportista() {
    this.apollo.watchQuery<any>({
      query: this.centroService.getCentrosByTransportista(),
      variables: {
       "id": this.idTransportista
      },
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        
        this.loading = loading;
        
        this.transportistaCentros = data.transportista.centros
     
        this.transportistaCentros.forEach((transportista:any) => {
            if(transportista.contratista?.id === this.userLog.contratista.id) {
                  this.arrayTransportistaCentros.push(transportista)
                }
            
        });
        this.setDataTableOptions(this.arrayTransportistaCentros)
        
      })
  }

  getCentrosByInstalacion() {
    this.apollo.watchQuery<any>({
      query: this.centroService.getCentrosByInstalacion(),
      variables: {
       "id": this.idInstalacion
      },
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.loading = loading;
      
        if (data.instalacion?.centro != null){
        this.arrayCentros.push(data.instalacion?.centro);
  
        }
         this.setDataTableOptions(this.arrayCentros)
      })
  }

  getCentroById(id:any){  
    this.apollo.watchQuery<any>({
      query: this.centroService.getCentroById(),
      variables: {
        id: id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
     
        this.getClienteById(data.centro.clientes[0].id)
        
        setTimeout(() => {
        
        const deleteCentro = this.centrosCliente.filter((centro:any) => centro.id != id)
     
        const deleteTransp = this.transportistaCliente.filter((transportista:any) => transportista.id == data.centro.transportistas.id)
        const deleteGestor = this.gestoresCliente.filter((gestor:any) => gestor.id == data.centro.gestors.id)
  
        this.updateClienteById(data.centro.clientes[0].id, deleteCentro, deleteTransp, deleteGestor)
        }, 800);
        
        
      })
  }

  updateClienteById(id:any, centro:any, transp:any, gestores:any){
    this.apollo.mutate({
      mutation: this.clienteService.updateCliente(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
          "data": {
            "centros": centro,
            "transportistas": transp,
            "gestores":gestores
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data, errors)
      }, (error) => {
        console.log('aaaaa',error)
      })
  }

  setDataTableOptions(data:any){
    this.dataSource = new MatTableDataSource(data)
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = (item: any, property: any) => {
      switch (property) {
        case 'cliente.nombreComercial': return item.cliente?.nombreComercial;
        case 'contactoResponsable.nombre': return item.contacto?.mail;
        case 'direccion.nombre': return item.direccion?.nombre
        default: return item[property];
        }
      };
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      return data.cliente?.nombreComercial?.toLocaleLowerCase().includes(filter) ||
        data.nombre.toLocaleLowerCase().includes(filter) ||
        data.contactoResponsable?.nombre.toLocaleLowerCase().includes(filter) ||
        data.direccion?.nombre?.toLocaleLowerCase().includes(filter) ||
        data.direccion?.tipoVia?.toLocaleLowerCase().includes(filter) ||
        data.direccion?.numero?.toLocaleLowerCase().includes(filter) ||
        data.direccion?.ccaa?.toLocaleLowerCase().includes(filter)
    }

  }


  deleteCentroById(id: String) {
    this.apollo.mutate({
      mutation: this.centroService.deleteCentro(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
        }
      }
    })
      .subscribe(({ data }) => {
        console.log('BORRADO', data)
      }, (error) => {
        console.log(error)
      })
  }

  handleClick(id: String) {
    const options = {
      text:'¿Está seguro de eliminar este registro?',
      cancelText: 'Cancelar',
      confirmText: 'Eliminar'
    };
    this.confirmacionService.open(options);
   
    this.confirmacionService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.getCentroById(id)
        setTimeout(() => {
          this.deleteCentroById(id)
          location.reload()
        }, 1500);
        
      }
    });
  }

  applyFilter(e: any) {
    this.filterValue = e.target.value
    this.dataSource.filter = this.filterValue?.trim().toLocaleLowerCase();
  }

  openDialog() {
   
    if (this.licenciasPagadas > 0) {
      this.dialog.open(NuevoCentroContratistaComponent);
      
    }

    if (this.licenciasPagadas == 0) {
          this.popupComprarLicencia()
        }
  }

  openDialogAddCliente(centroId:any) {

    if (this.licenciasPagadas > 0) {
      this.dialog.open(AddClienteComponent, {data:{
        centroId
      }});
     
    }

    if (this.licenciasPagadas == 0) {
         
          this.popupComprarLicencia()
        }
  }

  openDetails(id: any) {
    const options = {
      id: id
    }
    this.detalleService.openTest(options, DetalleCentroComponent)
  }

  getDocumentosByCentro(canvas: any) {
    const allDocCentros: any = []
    const allDocGestores: any = []
    const allDocTransportistas: any = []
    let allDocumentos: any = []
    this.apollo.watchQuery<any>({
      query: this.documentoService.getDocumentosByCentroBar(),
      variables: {
        id: canvas
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        let docCentros = data.centro.documentos
        let gestores = data.centro.gestors
        let transportistas = data.centro.transportistas

        gestores.forEach((gestor:any) => {
         gestor.documentos.forEach((element:any) => {
           allDocGestores.push(element)
         });
        });

        transportistas.forEach((transportista:any) => {
          transportista.documentos.forEach((element:any) => {
            allDocTransportistas.push(element)
          });
        });
        docCentros.forEach((docCentro: any) => {

          allDocCentros.push(docCentro)

        });

        allDocumentos=[...allDocCentros, ...allDocGestores, ...allDocTransportistas]
  
        const docCentrosActivos = allDocumentos.filter((doc: any) => doc.tipo === 'activo' || doc.tipo === 'enEspera');
  
        let docRojo = docCentrosActivos.filter((doc: any) => doc.estado == 'rojo');
        let docAmarillo = docCentrosActivos.filter((doc: any) => doc.estado == 'amarillo');
        let docVerde = docCentrosActivos.filter((doc: any) => doc.estado == 'verde')
        setTimeout(() => {
          this.stackedBarChartCentroMethod(Object.keys(docVerde).length, Object.keys(docRojo).length, Object.keys(docAmarillo).length, canvas)

        }, 300);

        
        let rojo = docRojo.length;
        let amarillo = docAmarillo.length;
        let verde = docVerde.length;

     /*    for (let i = 0; i < allDocumentos.length; i++) {
          if (allDocumentos[i].tipo != 'pendiente') {
            
          
          switch (allDocumentos[i].estado) {
            case 'rojo':
              rojo++;
              break;
            case 'amarillo':
              amarillo++;
              break;
            case 'verde':
              verde++;
              break;

            default:
              break;
          }
        }
      } */
          const centro = data.centro

          if (rojo > 0 && centro.estado == 'rojo' || centro.estado == null) {
            const estado = 'rojo'
            this.updateCentroById(centro.id, estado)
            return
          }
          if (amarillo > 0 && rojo == 0  && centro.estado == 'amarillo' || centro.estado == null) {
            const estado = 'amarillo'
            this.updateCentroById(centro.id, estado)
            return
          }
          if (verde > 0 && amarillo == 0 && rojo == 0 && centro.estado == 'verde' || centro.estado == null) {
            const estado = 'verde'
            this.updateCentroById(centro.id, estado)
            return
          }
        
        
      })
  }

  getDocumentosAdicByCentro(canvas: any) {
  
    this.apollo.watchQuery<any>({
      query: this.docAdicService.getDocumentosByCentro(),
      variables: {
        id: canvas
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        const allDocumentos = data.centro.documentos_adicionals;
        const docCentrosActivos = allDocumentos.filter((doc: any) => doc.tipo === 'activo' || doc.tipo === 'enEspera');
        console.log(docCentrosActivos);
        
        let docRojo = docCentrosActivos.filter((doc: any) => doc.estado == 'rojo');
        let docAmarillo = docCentrosActivos.filter((doc: any) => doc.estado == 'amarillo');
        let docVerde = docCentrosActivos.filter((doc: any) => doc.estado == 'verde')
        setTimeout(() => {
          this.stackedBarChartCentroAdicMethod(Object.keys(docVerde).length, Object.keys(docRojo).length, Object.keys(docAmarillo).length, canvas)

        }, 300);

       
          
        
        
      })
  }

  updateCentroById(id: any, estado: any) {
    this.apollo.mutate({
      mutation: this.centroService.updateCentro(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
          "data": {
            "estado": estado
          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data, errors)
      }, (error) => {
        console.log('aaaaa', error)
      })
  }


  stackedBarChartCentroMethod(fecha: any, caducado: any, proximo: any, canvas: any) {

    this.stackedBarChartCentro = new Chart('o'+canvas, {
      type: 'horizontalBar',

      data: {
        labels: ['Correcto', 'Próximo a caducar', 'Caducado'],
        datasets: [
          {
            data: [fecha],
            backgroundColor: '#00A131',
            label: 'Correcto'

          },
          {
            data: [proximo],
            backgroundColor: '#FF9E00',

          },
          {
            data: [caducado],
            backgroundColor: '#DC3737'

          }
        ]
      },
      options: this.stackedHorizontalBarOptions
    });

  }

  stackedBarChartCentroAdicMethod(fecha: any, caducado: any, proximo: any, canvas: any) {
console.log(fecha);

    this.stackedBarChartAdicCentro= new Chart('a'+canvas, {
      type: 'horizontalBar',

      data: {
        labels: ['Correcto', 'Próximo a caducar', 'Caducado'],
        datasets: [
          {
            data: [fecha],
            backgroundColor: '#00A131',
            label: 'Correcto'

          },
          {
            data: [proximo],
            backgroundColor: '#FF9E00',

          },
          {
            data: [caducado],
            backgroundColor: '#DC3737'

          }
        ]
      },
      options: this.stackedHorizontalBarOptions
    });

  }
/* 
  getDocumentosAllCentros() {
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getCentrosByContratista(),
      fetchPolicy: 'no-cache',
      variables: {
        "id": this.userLog.contratista.id,
      }
    }).valueChanges.subscribe(({ data, loading, errors }) => {
      let gestores:any =[]
      let transportistas:any =[]
      let stepGest:any =[]
      let stepTransp:any =[]
      const allDocGestores: any = []
      const allDocTransportistas: any = []
      const centros = data.contratista.centros;
      const docCentros: any = []
      const allDocCentros: any = []
      centros.forEach((centro: any) => {
        docCentros.push(centro.documentos)
        stepGest.push(centro.gestors)
        stepTransp.push(centro.transportistas)
      });

      docCentros.forEach((docCentro: any) => {
        docCentro.forEach((element: any) =>
          allDocCentros.push(element)
        )
      });
      stepGest.forEach((gestor:any) => {
        gestor.forEach((element:any) => {
          gestores.push(element)
        });
       });

       stepTransp.forEach((transportista:any) => {
         transportista.forEach((element:any) => {
           transportistas.push(element)
         });
       });

       gestores.forEach((gestor:any) => {
        gestor.documentos.forEach((element:any) => {
          allDocGestores.push(element)
        });
       });

       transportistas.forEach((transportista:any) => {
         transportista.documentos.forEach((element:any) => {
           allDocTransportistas.push(element)
         });
       });

      let allDocumentos = [...allDocCentros, ...allDocGestores, ...allDocTransportistas]
      const docCentrosActivos = allDocumentos.filter((doc: any) => doc.tipo === 'activo' || doc.tipo === 'enEspera');
      let docRojo = docCentrosActivos.filter((doc: any) => doc.estado == 'rojo');
      let docAmarillo = docCentrosActivos.filter((doc: any) => doc.estado == 'amarillo');
      let docVerde = docCentrosActivos.filter((doc: any) => doc.estado == 'verde')

      this.stackedBarChartTitleCentroMethod(Object.keys(docVerde).length, Object.keys(docRojo).length, Object.keys(docAmarillo).length)


    })
  }



  stackedBarChartTitleCentroMethod(fecha: any, caducado: any, proximo: any) {

    this.stackedBarChartTitleCentro = new Chart(this.stackedCanvasTitleCentro.nativeElement, {
      type: 'horizontalBar',

      data: {
        labels: ['Correcto', 'Próximo a caducar', 'Caducado'],
        datasets: [
          {
            data: [fecha],
            backgroundColor: '#00A131',
            label: 'Correcto'

          },
          {
            data: [proximo],
            backgroundColor: '#FF9E00',

          },
          {
            data: [caducado],
            backgroundColor: '#DC3737'

          }
        ]
      },
      options: this.stackedHorizontalBarOptions
    });

  }
 */
}
